import React from "react";
import PropTypes from "prop-types";
import {Col, Row, Spinner} from "react-bootstrap";
import Modals from "../../../../components/modals";

const componentName = "resetStatus";

const ResetStatusModal = ({
  show,
  onHide,
  onSubmit,
  patient,
  submitting,
  submitError,
  size = "md",
}) => (
  <Modals
    centered
    show={show}
    onHide={onHide}
    size={size}
    title="Reset Status"
    titleid={`${componentName}-ResetStatusModal`}
    body={
      <div>
        <Row className="mb-3">
          <Col>
            <span id={`${componentName}-patientNameLabel`} className="fw-bold d-block">
              Patient Name
            </span>
            <span id={`${componentName}-patientNameValue`} className="forced-capital d-block">
              {patient?.fullName || ""}
            </span>
          </Col>
        </Row>

        <Row className="mb-3">
          <Col>
            <p>
              This will reset the patient status back to the default (Unscheduled). Do you want to continue?
            </p>
          </Col>
        </Row>

        {submitError && (
          <Row className="mb-2">
            <Col>
              <div className="text-danger">{submitError}</div>
            </Col>
          </Row>
        )}

        {submitting && (
          <Row className="mb-1">
            <Col>
              <Spinner animation="border" size="sm" className="me-2" />
              <small className="text-muted">Resetting status...</small>
            </Col>
          </Row>
        )}
      </div>
    }
    completeBtn="Yes, Reset"
    completeBtnId={`${componentName}-ResetStatusSubmit`}
    closeBtn="Cancel"
    closeBtnId={`${componentName}-ResetStatusCancel`}
    onCreate={onSubmit}
  />
);

ResetStatusModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  patient: PropTypes.object,
  submitting: PropTypes.bool,
  submitError: PropTypes.string,
  size: PropTypes.string,
};

ResetStatusModal.defaultProps = {
  patient: null,
  submitting: false,
  submitError: null,
  size: "md",
};

export default ResetStatusModal;
